export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const STRIPE_PUBLISH_KEY = "pk_live_51PKPqGL8JXypyTWb4zLy4uHT43Pfn6p38QtNmku9DPtEKMUD2AOdpHKO2EpyeEzoOLr9K3R4nzc6GyZoySsHtliJ00RT2D4SOH";

export const USER_LOGIN_DATA = "USER_LOGIN_DATA";
export const CATEGORY_ID = "CATEGORY_ID";